module.exports = "/img/812a1ea7e43ee695efa1ba508cfa7ad3.svg";